// import React, { useState, useEffect } from 'react';

// import { Modal } from 'react-bootstrap';
// import {
//   FaWallet,
//   FaCheckCircle,
//   FaClock,
//   FaTimesCircle,
//   FaEye,
//   FaSearch,
//   FaChevronLeft,
//   FaChevronRight,
//   FaSpinner,
//   FaChartLine,
//   FaShoppingBag,
//   FaMoneyBillWave,
//   FaReceipt,
//   FaBox,
//   FaPalette,
// } from 'react-icons/fa';
// import './earnings.scss';

// import { toast } from 'react-toastify';
// import { serverUrlAuth } from '../../../../serverUrl';
// import FurnitureNavbar from '../../../../components/layout/Nav';
// import withAuth from '../../../auth/WithAuth';

// const ArtisanEarnings = () => {
//   const [earnings, setEarnings] = useState([]);
//   const [disbursements, setDisbursements] = useState([]);
//   const [summary, setSummary] = useState({
//     total_earned: 0,
//     total_paid: 0,
//     total_pending: 0,
//     total_orders: 0,
//   });
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedEarning, setSelectedEarning] = useState(null);
//   const [selectedDisbursement, setSelectedDisbursement] = useState(null);
//   const [showEarningModal, setShowEarningModal] = useState(false);
//   const [showDisbursementModal, setShowDisbursementModal] = useState(false);
//   const [activeTab, setActiveTab] = useState('earnings');
//   const [expandedEarning, setExpandedEarning] = useState(null);
//   const [expandedDisbursement, setExpandedDisbursement] = useState(null);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);

//   useEffect(() => {
//     fetchAllData();
//   }, []);

//   const fetchAllData = async () => {
//     try {
//       setLoading(true);
//       await Promise.all([
//         fetchEarnings(),
//         fetchDisbursements(),
//         fetchSummary(),
//       ]);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchEarnings = async () => {
//     try {
//       const response = await serverUrlAuth.get('artisan-ready-made-orders/artisan/earnings/');
//       console.log('Earnings response:', response.data);
//       setEarnings(response.data.earnings || []);
//     } catch (error) {
//       console.error('Error fetching earnings:', error);
//       toast.error('Failed to load earnings');
//     }
//   };

//   const fetchDisbursements = async () => {
//     try {
//       const response = await serverUrlAuth.get('disbursement/artisan/ready-made/');
//       console.log('Disbursements response:', response.data);
      
//       // The response has { status: true, count: X, disbursements: [...] }
//       const disbursementsData = response.data.disbursements || [];
//       setDisbursements(disbursementsData);
//     } catch (error) {
//       console.error('Error fetching disbursements:', error);
//       setDisbursements([]);
//     }
//   };

//   const fetchSummary = async () => {
//     try {
//       const response = await serverUrlAuth.get('artisan-ready-made-orders/artisan/earnings/summary/');
//       console.log('Summary response:', response.data);
//       setSummary(response.data);
//     } catch (error) {
//       console.error('Error fetching summary:', error);
//     }
//   };

//   const handleViewEarning = (earning) => {
//     setSelectedEarning(earning);
//     setShowEarningModal(true);
//   };

//   const handleViewDisbursement = (disbursement) => {
//     setSelectedDisbursement(disbursement);
//     setShowDisbursementModal(true);
//   };

//   const toggleExpandEarning = (earningId) => {
//     if (expandedEarning === earningId) {
//       setExpandedEarning(null);
//     } else {
//       setExpandedEarning(earningId);
//     }
//   };

//   const toggleExpandDisbursement = (disbursementId) => {
//     if (expandedDisbursement === disbursementId) {
//       setExpandedDisbursement(null);
//     } else {
//       setExpandedDisbursement(disbursementId);
//     }
//   };

//   const formatCurrency = (amount) => {
//     if (!amount || amount === 0) return 'KSh 0';
//     return `KSh ${parseFloat(amount).toLocaleString()}`;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   // Status config - just for display styling
//   const getStatusConfig = (status) => {
//     const configs = {
//       pending: {
//         label: 'Pending',
//         color: '#F59E0B',
//         bg: '#FEF3C7',
//         icon: FaClock,
//       },
//       partially_paid: {
//         label: 'Partially Paid',
//         color: '#3B82F6',
//         bg: '#DBEAFE',
//         icon: FaClock,
//       },
//       paid: {
//         label: 'Paid',
//         color: '#10B981',
//         bg: '#D1FAE5',
//         icon: FaCheckCircle,
//       },
//     };
//     return configs[status] || configs.pending;
//   };

//   // Filter earnings
//   const filteredEarnings = earnings.filter((earning) => {
//     const matchesSearch =
//       earning.id?.toString().includes(searchTerm) ||
//       earning.customer_order_id?.toString().includes(searchTerm) ||
//       earning.artisan_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       earning.products?.some(p => 
//         p.product_name?.toLowerCase().includes(searchTerm.toLowerCase())
//       );

//     return matchesSearch;
//   });

//   // Filter disbursements
//   const filteredDisbursements = disbursements.filter((disb) => {
//     const matchesSearch =
//       disb.id?.toString().includes(searchTerm) ||
//       disb.earning_id?.toString().includes(searchTerm) ||
//       disb.transaction_reference?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       disb.products?.some(p => 
//         p.product_name?.toLowerCase().includes(searchTerm.toLowerCase())
//       );

//     return matchesSearch;
//   });

//   // Pagination
//   const currentData = activeTab === 'earnings' ? filteredEarnings : filteredDisbursements;
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = currentData.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(currentData.length / itemsPerPage);

//   const paginate = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Get product summary for display
//   const getProductSummary = (products) => {
//     if (!products || products.length === 0) return 'No products';
//     if (products.length === 1) {
//       return products[0].product_name;
//     }
//     return `${products[0].product_name} +${products.length - 1} more`;
//   };

//   // Get all product names for disbursement
//   const getDisbursementProductNames = (disbursement) => {
//     if (!disbursement.products || disbursement.products.length === 0) {
//       return 'No products';
//     }
//     return disbursement.products.map(p => p.product_name).join(', ');
//   };

//   // Get product summary for disbursement display
//   const getDisbursementProductSummary = (disbursement) => {
//     if (!disbursement.products || disbursement.products.length === 0) {
//       return 'No products';
//     }
//     if (disbursement.products.length === 1) {
//       return disbursement.products[0].product_name;
//     }
//     return `${disbursement.products[0].product_name} +${disbursement.products.length - 1} more`;
//   };

//   if (loading) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="artisan-earnings-page">
//           <div className="loading-container">
//             <FaSpinner className="spinner" />
//             <p>Loading earnings...</p>
//           </div>
//         </div>
//       </>
//     );
//   }

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="artisan-earnings-page">
//         <div className="earnings-container">
//           {/* Header */}
//           <div className="earnings-header">
//             <div className="header-left">
//               <h1>💰 Earnings & Payments</h1>
//               <p className="earnings-count">
//                 {earnings.length} earning{earnings.length !== 1 ? 's' : ''} ·{' '}
//                 {disbursements.length} payment{disbursements.length !== 1 ? 's' : ''} received
//               </p>
//             </div>
//           </div>

//           {/* Summary Cards */}
//           <div className="summary-cards">
//             <div className="summary-card total">
//               <div className="card-icon">
//                 <FaWallet />
//               </div>
//               <div className="card-info">
//                 <div className="card-value">{formatCurrency(summary.total_earned)}</div>
//                 <div className="card-label">Total Earned</div>
//               </div>
//             </div>

//             <div className="summary-card paid">
//               <div className="card-icon">
//                 <FaCheckCircle />
//               </div>
//               <div className="card-info">
//                 <div className="card-value">{formatCurrency(summary.total_paid)}</div>
//                 <div className="card-label">Paid</div>
//               </div>
//             </div>

//             <div className="summary-card pending">
//               <div className="card-icon">
//                 <FaClock />
//               </div>
//               <div className="card-info">
//                 <div className="card-value">{formatCurrency(summary.total_pending)}</div>
//                 <div className="card-label">Pending</div>
//               </div>
//             </div>
//           </div>

//           {/* Tabs */}
//           <div className="tabs-container">
//             <button
//               className={`tab-btn ${activeTab === 'earnings' ? 'active' : ''}`}
//               onClick={() => {
//                 setActiveTab('earnings');
//                 setCurrentPage(1);
//                 setSearchTerm('');
//               }}
//             >
//               <FaMoneyBillWave /> Earnings Owed
//               <span className="tab-count">{earnings.length}</span>
//             </button>
//             <button
//               className={`tab-btn ${activeTab === 'disbursements' ? 'active' : ''}`}
//               onClick={() => {
//                 setActiveTab('disbursements');
//                 setCurrentPage(1);
//                 setSearchTerm('');
//               }}
//             >
//               <FaReceipt /> Payments Received
//               <span className="tab-count">{disbursements.length}</span>
//             </button>
//           </div>

//           {/* Filters */}
//           <div className="filters-bar">
//             <div className="search-box">
//               <FaSearch />
//               <input
//                 type="text"
//                 placeholder={
//                   activeTab === 'earnings'
//                     ? 'Search by earning ID, order, or product...'
//                     : 'Search by payment ID, product, or reference...'
//                 }
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//               {searchTerm && (
//                 <button className="clear-search" onClick={() => setSearchTerm('')}>
//                   ×
//                 </button>
//               )}
//             </div>
//             <div className="filter-info">
//               <span className="results-count">
//                 Showing {currentItems.length} of {currentData.length}
//               </span>
//             </div>
//           </div>

//           {/* Content */}
//           {currentItems.length === 0 ? (
//             <div className="empty-state">
//               <div className="empty-icon">
//                 {activeTab === 'earnings' ? <FaChartLine /> : <FaReceipt />}
//               </div>
//               <h2>
//                 {activeTab === 'earnings' ? 'No earnings yet' : 'No payments yet'}
//               </h2>
//               <p>
//                 {activeTab === 'earnings'
//                   ? 'Your earnings will appear here once you start receiving orders'
//                   : 'Your payments will appear here once Artiza disburses funds to you'}
//               </p>
//             </div>
//           ) : (
//             <>
//               <div className="earnings-table-wrapper">
//                 <table className="earnings-table">
//                   <thead>
//                     <tr>
//                       {activeTab === 'earnings' ? (
//                         <>
//                           <th>Earning ID</th>
//                           <th>Order</th>
//                           <th>Products</th>
//                           <th>Colors</th>
//                           <th>Gross</th>
//                           <th>Commission</th>
//                           <th>Net</th>
//                           <th>Paid</th>
//                           <th>Remaining</th>
//                           <th>Status</th>
//                           <th>Date</th>
//                           <th>Actions</th>
//                         </>
//                       ) : (
//                         <>
//                           <th>Payment ID</th>
//                           <th>Products</th>
//                           <th>Amount</th>
//                           <th>Method</th>
//                           <th>Reference</th>
//                           <th>Date</th>
//                           <th>Actions</th>
//                         </>
//                       )}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentItems.map((item) => {
//                       if (activeTab === 'earnings') {
//                         const earning = item;
//                         const statusConfig = getStatusConfig(earning.status);
//                         const StatusIcon = statusConfig.icon;
//                         const products = earning.products || [];
//                         const isExpanded = expandedEarning === earning.id;

//                         return (
//                           <React.Fragment key={earning.id}>
//                             <tr className={earning.status}>
//                               <td>
//                                 <div className="earning-id">#{earning.id}</div>
//                               </td>
//                               <td>
//                                 <div className="order-info">
//                                   <div className="order-id">#{earning.customer_order_id}</div>
//                                   <div className="order-artisan">{earning.artisan_name}</div>
//                                 </div>
//                               </td>
//                               <td>
//                                 <div className="product-info-cell">
//                                   {products.length > 0 && products[0].product_image && (
//                                     <img
//                                       src={products[0].product_image}
//                                       alt={products[0].product_name}
//                                       className="product-thumb-small"
//                                     />
//                                   )}
//                                   <div className="product-names">
//                                     <span className="product-name-main">
//                                       {getProductSummary(products)}
//                                     </span>
//                                     {products.length > 1 && (
//                                       <button
//                                         className="expand-btn"
//                                         onClick={() => toggleExpandEarning(earning.id)}
//                                       >
//                                         {isExpanded ? 'Hide' : 'Show all'} ({products.length})
//                                       </button>
//                                     )}
//                                   </div>
//                                 </div>
//                               </td>
//                               <td>
//                                 <div className="color-info-cell">
//                                   {products.slice(0, 3).map((product, idx) => (
//                                     product.color_name && (
//                                       <span key={idx} className="color-item">
//                                         <span
//                                           className="color-dot-small"
//                                           style={{
//                                             backgroundColor: product.color_code || '#ccc',
//                                           }}
//                                         />
//                                         <span className="color-name-small">
//                                           {product.color_name}
//                                         </span>
//                                       </span>
//                                     )
//                                   ))}
//                                   {products.length > 3 && (
//                                     <span className="more-colors">
//                                       +{products.length - 3}
//                                     </span>
//                                   )}
//                                 </div>
//                               </td>
//                               <td className="amount">{formatCurrency(earning.gross_amount)}</td>
//                               <td className="commission">
//                                 <div className="commission-details">
//                                   <span className="commission-rate">
//                                     {earning.commission_rate}%
//                                   </span>
//                                   <span className="commission-amount">
//                                     -{formatCurrency(earning.commission_amount)}
//                                   </span>
//                                 </div>
//                               </td>
//                               <td className="net-amount">
//                                 <strong>{formatCurrency(earning.net_amount)}</strong>
//                               </td>
//                               <td className="amount">
//                                 {earning.amount_disbursed > 0
//                                   ? formatCurrency(earning.amount_disbursed)
//                                   : '—'}
//                               </td>
//                               <td className="amount">
//                                 {earning.amount_remaining > 0
//                                   ? formatCurrency(earning.amount_remaining)
//                                   : '—'}
//                               </td>
//                               <td>
//                                 <span
//                                   className="status-badge"
//                                   style={{
//                                     background: statusConfig.bg,
//                                     color: statusConfig.color,
//                                   }}
//                                 >
//                                   <StatusIcon />
//                                   {statusConfig.label}
//                                 </span>
//                               </td>
//                               <td>
//                                 <div className="earning-date">
//                                   {formatDate(earning.created_at)}
//                                 </div>
//                               </td>
//                               <td>
//                                 <div className="action-buttons">
//                                   <button
//                                     className="view-btn"
//                                     onClick={() => handleViewEarning(earning)}
//                                     title="View details"
//                                   >
//                                     <FaEye />
//                                   </button>
//                                 </div>
//                               </td>
//                             </tr>
//                             {/* Expanded Products Row */}
//                             {isExpanded && products.length > 1 && (
//                               <tr className="expanded-products-row">
//                                 <td colSpan="12">
//                                   <div className="expanded-products">
//                                     <div className="expanded-products-header">
//                                       <FaBox /> Products in this order
//                                     </div>
//                                     <div className="expanded-products-list">
//                                       {products.map((product, idx) => (
//                                         <div key={idx} className="expanded-product-item">
//                                           <div className="expanded-product-image">
//                                             {product.product_image ? (
//                                               <img
//                                                 src={product.product_image}
//                                                 alt={product.product_name}
//                                               />
//                                             ) : (
//                                               <div className="no-image">
//                                                 <FaBox />
//                                               </div>
//                                             )}
//                                           </div>
//                                           <div className="expanded-product-details">
//                                             <div className="expanded-product-name">
//                                               {product.product_name}
//                                             </div>
//                                             <div className="expanded-product-meta">
//                                               {product.color_name && (
//                                                 <span className="expanded-product-color">
//                                                   <span
//                                                     className="color-dot"
//                                                     style={{
//                                                       backgroundColor:
//                                                         product.color_code || '#ccc',
//                                                     }}
//                                                   />
//                                                   {product.color_name}
//                                                 </span>
//                                               )}
//                                               <span className="expanded-product-qty">
//                                                 Qty: {product.quantity}
//                                               </span>
//                                               <span className="expanded-product-price">
//                                                 {formatCurrency(product.unit_price)} each
//                                               </span>
//                                             </div>
//                                           </div>
//                                           <div className="expanded-product-total">
//                                             {formatCurrency(product.total_price)}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 </td>
//                               </tr>
//                             )}
//                           </React.Fragment>
//                         );
//                       } else {
//                         // DISBURSEMENTS TAB
//                         const disbursement = item;
//                         const products = disbursement.products || [];
//                         const isExpanded = expandedDisbursement === disbursement.id;

//                         return (
//                           <React.Fragment key={disbursement.id}>
//                             <tr>
//                               <td>
//                                 <div className="disbursement-id">#{disbursement.id}</div>
//                               </td>
//                               <td>
//                                 <div className="product-info-cell">
//                                   {products.length > 0 && products[0].product_image && (
//                                     <img
//                                       src={products[0].product_image}
//                                       alt={products[0].product_name}
//                                       className="product-thumb-small"
//                                     />
//                                   )}
//                                   <div className="product-names">
//                                     <span className="product-name-main">
//                                       {getDisbursementProductSummary(disbursement)}
//                                     </span>
//                                     {products.length > 1 && (
//                                       <button
//                                         className="expand-btn"
//                                         onClick={() => toggleExpandDisbursement(disbursement.id)}
//                                       >
//                                         {isExpanded ? 'Hide' : 'Show all'} ({products.length})
//                                       </button>
//                                     )}
//                                   </div>
//                                 </div>
//                               </td>
//                               <td className="amount">
//                                 <strong>{formatCurrency(disbursement.amount)}</strong>
//                               </td>
//                               <td>
//                                 <span
//                                   className={`payment-method-badge ${disbursement.payment_method}`}
//                                 >
//                                   {disbursement.payment_method === 'mpesa'
//                                     ? '📱 M-Pesa'
//                                     : '🏦 Bank'}
//                                 </span>
//                               </td>
//                               <td>
//                                 <span className="reference-text">
//                                   {disbursement.transaction_reference || 'N/A'}
//                                 </span>
//                               </td>
//                               <td>
//                                 <div className="disbursement-date">
//                                   {formatDate(
//                                     disbursement.disbursed_at || disbursement.created_at
//                                   )}
//                                 </div>
//                               </td>
//                               <td>
//                                 <div className="action-buttons">
//                                   <button
//                                     className="view-btn"
//                                     onClick={() => handleViewDisbursement(disbursement)}
//                                     title="View details"
//                                   >
//                                     <FaEye />
//                                   </button>
//                                 </div>
//                               </td>
//                             </tr>
//                             {/* Expanded Products Row for Disbursement */}
//                             {isExpanded && products.length > 1 && (
//                               <tr className="expanded-products-row">
//                                 <td colSpan="7">
//                                   <div className="expanded-products">
//                                     <div className="expanded-products-header">
//                                       <FaBox /> Products in this payment
//                                     </div>
//                                     <div className="expanded-products-list">
//                                       {products.map((product, idx) => (
//                                         <div key={idx} className="expanded-product-item">
//                                           <div className="expanded-product-image">
//                                             {product.product_image ? (
//                                               <img
//                                                 src={product.product_image}
//                                                 alt={product.product_name}
//                                               />
//                                             ) : (
//                                               <div className="no-image">
//                                                 <FaBox />
//                                               </div>
//                                             )}
//                                           </div>
//                                           <div className="expanded-product-details">
//                                             <div className="expanded-product-name">
//                                               {product.product_name}
//                                             </div>
//                                             <div className="expanded-product-meta">
//                                               {product.color_name && (
//                                                 <span className="expanded-product-color">
//                                                   <span
//                                                     className="color-dot"
//                                                     style={{
//                                                       backgroundColor:
//                                                         product.color_code || '#ccc',
//                                                     }}
//                                                   />
//                                                   {product.color_name}
//                                                 </span>
//                                               )}
//                                               <span className="expanded-product-qty">
//                                                 Qty: {product.quantity}
//                                               </span>
//                                               <span className="expanded-product-price">
//                                                 {formatCurrency(product.unit_price)} each
//                                               </span>
//                                             </div>
//                                           </div>
//                                           <div className="expanded-product-total">
//                                             {formatCurrency(product.total_price)}
//                                           </div>
//                                         </div>
//                                       ))}
//                                     </div>
//                                   </div>
//                                 </td>
//                               </tr>
//                             )}
//                           </React.Fragment>
//                         );
//                       }
//                     })}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Pagination */}
//               {totalPages > 1 && (
//                 <div className="pagination">
//                   <button
//                     className="pagination-btn"
//                     onClick={() => paginate(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   >
//                     <FaChevronLeft />
//                   </button>
//                   <span className="page-info">
//                     Page {currentPage} of {totalPages}
//                   </span>
//                   <button
//                     className="pagination-btn"
//                     onClick={() => paginate(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   >
//                     <FaChevronRight />
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </div>

//         {/* ============================================= */}
//         {/* EARNING DETAIL MODAL */}
//         {/* ============================================= */}
//         <Modal
//           show={showEarningModal}
//           onHide={() => setShowEarningModal(false)}
//           size="xl"
//           centered
//           className="earning-detail-modal"
//         >
//           {selectedEarning && (
//             <>
//               <Modal.Header closeButton>
//                 <h2>Earning Details</h2>
//               </Modal.Header>
//               <Modal.Body>
//                 <div className="earning-detail-content">
//                   {/* Header Summary */}
//                   <div className="earning-summary-header">
//                     <div className="earning-main-info">
//                       <div className="earning-id-badge">Earning #{selectedEarning.id}</div>
//                       <div className="earning-amount-large">
//                         {formatCurrency(selectedEarning.net_amount)}
//                       </div>
//                       <div className="earning-status">
//                         {(() => {
//                           const config = getStatusConfig(selectedEarning.status);
//                           const Icon = config.icon;
//                           return (
//                             <span
//                               className="status-badge-large"
//                               style={{
//                                 background: config.bg,
//                                 color: config.color,
//                               }}
//                             >
//                               <Icon />
//                               {config.label}
//                             </span>
//                           );
//                         })()}
//                       </div>
//                     </div>
//                   </div>

//                   {/* Products Section */}
//                   {selectedEarning.products && selectedEarning.products.length > 0 && (
//                     <div className="products-section">
//                       <h4>
//                         <FaBox /> Products
//                       </h4>
//                       <div className="products-list">
//                         {selectedEarning.products.map((product, idx) => (
//                           <div key={idx} className="product-item">
//                             <div className="product-image">
//                               {product.product_image ? (
//                                 <img src={product.product_image} alt={product.product_name} />
//                               ) : (
//                                 <div className="no-image">
//                                   <FaBox />
//                                 </div>
//                               )}
//                             </div>
//                             <div className="product-details">
//                               <div className="product-name">{product.product_name}</div>
//                               <div className="product-meta">
//                                 {product.color_name && (
//                                   <span className="product-color">
//                                     <span
//                                       className="color-dot"
//                                       style={{
//                                         backgroundColor: product.color_code || '#ccc',
//                                       }}
//                                     />
//                                     {product.color_name}
//                                   </span>
//                                 )}
//                                 <span className="product-qty">Qty: {product.quantity}</span>
//                                 <span className="product-price">
//                                   {formatCurrency(product.unit_price)} each
//                                 </span>
//                               </div>
//                             </div>
//                             <div className="product-total">
//                               {formatCurrency(product.total_price)}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                   {/* Financial Breakdown */}
//                   <div className="financial-breakdown">
//                     <h4>Financial Breakdown</h4>
//                     <div className="breakdown-grid">
//                       <div className="breakdown-item">
//                         <span className="breakdown-label">Gross Amount</span>
//                         <span className="breakdown-value">
//                           {formatCurrency(selectedEarning.gross_amount)}
//                         </span>
//                       </div>
//                       <div className="breakdown-item">
//                         <span className="breakdown-label">
//                           Commission ({selectedEarning.commission_rate}%)
//                         </span>
//                         <span className="breakdown-value negative">
//                           -{formatCurrency(selectedEarning.commission_amount)}
//                         </span>
//                       </div>
//                       <div className="breakdown-item total">
//                         <span className="breakdown-label">Net Amount</span>
//                         <span className="breakdown-value total">
//                           {formatCurrency(selectedEarning.net_amount)}
//                         </span>
//                       </div>
//                       <div className="breakdown-item">
//                         <span className="breakdown-label">Amount Paid</span>
//                         <span className="breakdown-value">
//                           {formatCurrency(selectedEarning.amount_disbursed || 0)}
//                         </span>
//                       </div>
//                       <div className="breakdown-item">
//                         <span className="breakdown-label">Remaining</span>
//                         <span className="breakdown-value">
//                           {formatCurrency(selectedEarning.amount_remaining || 0)}
//                         </span>
//                       </div>
//                       {selectedEarning.paid_at && (
//                         <div className="breakdown-item">
//                           <span className="breakdown-label">Paid At</span>
//                           <span className="breakdown-value">
//                             {formatDate(selectedEarning.paid_at)}
//                           </span>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Order Information */}
//                   <div className="order-information">
//                     <h4>Order Information</h4>
//                     <div className="info-grid">
//                       <div className="info-item">
//                         <span className="info-label">Order ID</span>
//                         <span className="info-value">
//                           #{selectedEarning.customer_order_id}
//                         </span>
//                       </div>
//                       <div className="info-item">
//                         <span className="info-label">Artisan</span>
//                         <span className="info-value">{selectedEarning.artisan_name}</span>
//                       </div>
//                       <div className="info-item">
//                         <span className="info-label">Email</span>
//                         <span className="info-value">{selectedEarning.artisan_email}</span>
//                       </div>
//                       <div className="info-item">
//                         <span className="info-label">Created</span>
//                         <span className="info-value">
//                           {formatDate(selectedEarning.created_at)}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </Modal.Body>
//               <Modal.Footer>
//                 <button
//                   className="btn btn-secondary"
//                   onClick={() => setShowEarningModal(false)}
//                 >
//                   Close
//                 </button>
//               </Modal.Footer>
//             </>
//           )}
//         </Modal>

//         {/* ============================================= */}
//         {/* DISBURSEMENT DETAIL MODAL */}
//         {/* ============================================= */}
//         <Modal
//           show={showDisbursementModal}
//           onHide={() => setShowDisbursementModal(false)}
//           size="lg"
//           centered
//           className="disbursement-detail-modal"
//         >
//           {selectedDisbursement && (
//             <>
//               <Modal.Header closeButton>
//                 <h2>Payment Details</h2>
//               </Modal.Header>
//               <Modal.Body>
//                 <div className="disbursement-detail-content">
//                   {/* Header Summary */}
//                   <div className="disbursement-summary-header">
//                     <div className="disbursement-main-info">
//                       <div className="disbursement-id-badge">
//                         Payment #{selectedDisbursement.id}
//                       </div>
//                       <div className="disbursement-amount-large">
//                         {formatCurrency(selectedDisbursement.amount)}
//                       </div>
//                       <div className="disbursement-method">
//                         <span
//                           className={`method-badge ${selectedDisbursement.payment_method}`}
//                         >
//                           {selectedDisbursement.payment_method === 'mpesa'
//                             ? '📱 M-Pesa'
//                             : '🏦 Bank Transfer'}
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Products Section */}
//                   {selectedDisbursement.products && selectedDisbursement.products.length > 0 && (
//                     <div className="products-section">
//                       <h4>
//                         <FaBox /> Products in this payment
//                       </h4>
//                       <div className="products-list">
//                         {selectedDisbursement.products.map((product, idx) => (
//                           <div key={idx} className="product-item">
//                             <div className="product-image">
//                               {product.product_image ? (
//                                 <img src={product.product_image} alt={product.product_name} />
//                               ) : (
//                                 <div className="no-image">
//                                   <FaBox />
//                                 </div>
//                               )}
//                             </div>
//                             <div className="product-details">
//                               <div className="product-name">{product.product_name}</div>
//                               <div className="product-meta">
//                                 {product.color_name && (
//                                   <span className="product-color">
//                                     <span
//                                       className="color-dot"
//                                       style={{
//                                         backgroundColor: product.color_code || '#ccc',
//                                       }}
//                                     />
//                                     {product.color_name}
//                                   </span>
//                                 )}
//                                 <span className="product-qty">Qty: {product.quantity}</span>
//                                 <span className="product-price">
//                                   {formatCurrency(product.unit_price)} each
//                                 </span>
//                               </div>
//                             </div>
//                             <div className="product-total">
//                               {formatCurrency(product.total_price)}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}

//                   {/* Payment Details */}
//                   <div className="disbursement-details-grid">
//                     <div className="detail-item">
//                       <span className="label">Earning ID</span>
//                       <span className="value">
//                         #{selectedDisbursement.earning_id || 'N/A'}
//                       </span>
//                     </div>
//                     <div className="detail-item">
//                       <span className="label">Order ID</span>
//                       <span className="value">
//                         #{selectedDisbursement.customer_order_id || 'N/A'}
//                       </span>
//                     </div>
//                     <div className="detail-item">
//                       <span className="label">Transaction Reference</span>
//                       <span className="value">
//                         {selectedDisbursement.transaction_reference || 'N/A'}
//                       </span>
//                     </div>
//                     <div className="detail-item">
//                       <span className="label">Payment Date</span>
//                       <span className="value">
//                         {formatDate(
//                           selectedDisbursement.disbursed_at ||
//                             selectedDisbursement.created_at
//                         )}
//                       </span>
//                     </div>
//                     {/* ❌ No notes - artisan doesn't see admin notes */}
//                   </div>
//                 </div>
//               </Modal.Body>
//               <Modal.Footer>
//                 <button
//                   className="btn btn-secondary"
//                   onClick={() => setShowDisbursementModal(false)}
//                 >
//                   Close
//                 </button>
//               </Modal.Footer>
//             </>
//           )}
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default withAuth(ArtisanEarnings, 'artisan');



// src/pages/artisan/earnings/ArtisanEarnings.jsx
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import {
  FaWallet,
  FaCheckCircle,
  FaClock,
  FaTimesCircle,
  FaEye,
  FaSearch,
  FaChevronLeft,
  FaChevronRight,
  FaSpinner,
  FaChartLine,
  FaShoppingBag,
  FaMoneyBillWave,
  FaReceipt,
  FaBox,
  FaPalette,
} from 'react-icons/fa';
import './earnings.scss';
import { toast } from 'react-toastify';
import { serverUrlAuth } from '../../../../serverUrl';
import Sidebar from '../../../../components/layout/Sidebar';
import withAuth from '../../../auth/WithAuth';

const ArtisanEarnings = () => {
  const [earnings, setEarnings] = useState([]);
  const [disbursements, setDisbursements] = useState([]);
  const [summary, setSummary] = useState({
    total_earned: 0,
    total_paid: 0,
    total_pending: 0,
    total_orders: 0,
  });
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedEarning, setSelectedEarning] = useState(null);
  const [selectedDisbursement, setSelectedDisbursement] = useState(null);
  const [showEarningModal, setShowEarningModal] = useState(false);
  const [showDisbursementModal, setShowDisbursementModal] = useState(false);
  const [activeTab, setActiveTab] = useState('earnings');
  const [expandedEarning, setExpandedEarning] = useState(null);
  const [expandedDisbursement, setExpandedDisbursement] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        fetchEarnings(),
        fetchDisbursements(),
        fetchSummary(),
      ]);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchEarnings = async () => {
    try {
      const response = await serverUrlAuth.get(
        'artisan-ready-made-orders/artisan/earnings/',
      );
      console.log('Earnings response:', response.data);
      setEarnings(response.data.earnings || []);
    } catch (error) {
      console.error('Error fetching earnings:', error);
      toast.error('Failed to load earnings');
    }
  };

  const fetchDisbursements = async () => {
    try {
      const response = await serverUrlAuth.get(
        'disbursement/artisan/ready-made/',
      );
      console.log('Disbursements response:', response.data);
      const disbursementsData = response.data.disbursements || [];
      setDisbursements(disbursementsData);
    } catch (error) {
      console.error('Error fetching disbursements:', error);
      setDisbursements([]);
    }
  };

  const fetchSummary = async () => {
    try {
      const response = await serverUrlAuth.get(
        'artisan-ready-made-orders/artisan/earnings/summary/',
      );
      console.log('Summary response:', response.data);
      setSummary(response.data);
    } catch (error) {
      console.error('Error fetching summary:', error);
    }
  };

  const handleViewEarning = (earning) => {
    setSelectedEarning(earning);
    setShowEarningModal(true);
  };

  const handleViewDisbursement = (disbursement) => {
    setSelectedDisbursement(disbursement);
    setShowDisbursementModal(true);
  };

  const toggleExpandEarning = (earningId) => {
    if (expandedEarning === earningId) {
      setExpandedEarning(null);
    } else {
      setExpandedEarning(earningId);
    }
  };

  const toggleExpandDisbursement = (disbursementId) => {
    if (expandedDisbursement === disbursementId) {
      setExpandedDisbursement(null);
    } else {
      setExpandedDisbursement(disbursementId);
    }
  };

  const formatCurrency = (amount) => {
    if (!amount || amount === 0) return 'KSh 0';
    return `KSh ${parseFloat(amount).toLocaleString()}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getStatusConfig = (status) => {
    const configs = {
      pending: {
        label: 'Pending',
        color: '#F59E0B',
        bg: '#FEF3C7',
        icon: FaClock,
      },
      partially_paid: {
        label: 'Partially Paid',
        color: '#3B82F6',
        bg: '#DBEAFE',
        icon: FaClock,
      },
      paid: {
        label: 'Paid',
        color: '#10B981',
        bg: '#D1FAE5',
        icon: FaCheckCircle,
      },
    };
    return configs[status] || configs.pending;
  };

  // Filter earnings
  const filteredEarnings = earnings.filter((earning) => {
    const matchesSearch =
      earning.id?.toString().includes(searchTerm) ||
      earning.customer_order_id?.toString().includes(searchTerm) ||
      earning.artisan_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      earning.products?.some((p) =>
        p.product_name?.toLowerCase().includes(searchTerm.toLowerCase()),
      );

    return matchesSearch;
  });

  // Filter disbursements
  const filteredDisbursements = disbursements.filter((disb) => {
    const matchesSearch =
      disb.id?.toString().includes(searchTerm) ||
      disb.earning_id?.toString().includes(searchTerm) ||
      disb.transaction_reference
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      disb.products?.some((p) =>
        p.product_name?.toLowerCase().includes(searchTerm.toLowerCase()),
      );

    return matchesSearch;
  });

  // Pagination
  const currentData =
    activeTab === 'earnings' ? filteredEarnings : filteredDisbursements;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = currentData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(currentData.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getProductSummary = (products) => {
    if (!products || products.length === 0) return 'No products';
    if (products.length === 1) return products[0].product_name;
    return `${products[0].product_name} +${products.length - 1} more`;
  };

  const getDisbursementProductNames = (disbursement) => {
    if (!disbursement.products || disbursement.products.length === 0) {
      return 'No products';
    }
    return disbursement.products.map((p) => p.product_name).join(', ');
  };

  const getDisbursementProductSummary = (disbursement) => {
    if (!disbursement.products || disbursement.products.length === 0) {
      return 'No products';
    }
    if (disbursement.products.length === 1) {
      return disbursement.products[0].product_name;
    }
    return `${disbursement.products[0].product_name} +${
      disbursement.products.length - 1
    } more`;
  };

  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="modern-dashboard artisan-earnings-page">
          <div className="loading-container">
            <FaSpinner className="spinner" />
            <p>Loading earnings...</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard artisan-earnings-page">
        <div className="earnings-container">
          {/* ============================================================
              HERO SECTION — rich floating circles
             ============================================================ */}
          {/* <section className="hero-banner">
            <div className="hero-pattern"></div>

            <span className="hero-circle hero-circle-1"></span>
            <span className="hero-circle hero-circle-2"></span>
            <span className="hero-circle hero-circle-3"></span>
            <span className="hero-circle hero-circle-4"></span>
            <span className="hero-circle hero-circle-5"></span>
            <span className="hero-circle hero-circle-6"></span>
            <span className="hero-circle hero-circle-7"></span>
            <span className="hero-circle hero-circle-8"></span>
            <span className="hero-circle hero-circle-9"></span>
            <span className="hero-circle hero-circle-10"></span>

            <div className="hero-overlay">
              <div className="hero-content">
                <h1>
                  <span className="gradient-text">💰 Earnings &</span> Payments
                </h1>
                <p>
                  Track your ready-made product earnings and view payment
                  history — all in one place.
                </p>
              </div>
            </div>
          </section> */}

          {/* Header */}
          <div className="earnings-header">
            <div className="header-left">
              <h1>💰 Earnings & Payments</h1>
              <p className="earnings-count">
                {earnings.length} earning{earnings.length !== 1 ? 's' : ''} ·{' '}
                {disbursements.length} payment
                {disbursements.length !== 1 ? 's' : ''} received
              </p>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="summary-cards">
            <div className="summary-card total">
              <div className="card-icon">
                <FaWallet />
              </div>
              <div className="card-info">
                <div className="card-value">
                  {formatCurrency(summary.total_earned)}
                </div>
                <div className="card-label">Total Earned</div>
              </div>
            </div>

            <div className="summary-card paid">
              <div className="card-icon">
                <FaCheckCircle />
              </div>
              <div className="card-info">
                <div className="card-value">
                  {formatCurrency(summary.total_paid)}
                </div>
                <div className="card-label">Paid</div>
              </div>
            </div>

            <div className="summary-card pending">
              <div className="card-icon">
                <FaClock />
              </div>
              <div className="card-info">
                <div className="card-value">
                  {formatCurrency(summary.total_pending)}
                </div>
                <div className="card-label">Pending</div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="tabs-container">
            <button
              className={`tab-btn ${
                activeTab === 'earnings' ? 'active' : ''
              }`}
              onClick={() => {
                setActiveTab('earnings');
                setCurrentPage(1);
                setSearchTerm('');
              }}
            >
              <FaMoneyBillWave /> Earnings Owed
              <span className="tab-count">{earnings.length}</span>
            </button>
            <button
              className={`tab-btn ${
                activeTab === 'disbursements' ? 'active' : ''
              }`}
              onClick={() => {
                setActiveTab('disbursements');
                setCurrentPage(1);
                setSearchTerm('');
              }}
            >
              <FaReceipt /> Payments Received
              <span className="tab-count">{disbursements.length}</span>
            </button>
          </div>

          {/* Filters */}
          <div className="filters-bar">
            <div className="search-box">
              <FaSearch />
              <input
                type="text"
                placeholder={
                  activeTab === 'earnings'
                    ? 'Search by earning ID, order, or product...'
                    : 'Search by payment ID, product, or reference...'
                }
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button
                  className="clear-search"
                  onClick={() => setSearchTerm('')}
                >
                  ×
                </button>
              )}
            </div>
            <div className="filter-info">
              <span className="results-count">
                Showing {currentItems.length} of {currentData.length}
              </span>
            </div>
          </div>

          {/* Content */}
          {currentItems.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">
                {activeTab === 'earnings' ? <FaChartLine /> : <FaReceipt />}
              </div>
              <h2>
                {activeTab === 'earnings'
                  ? 'No earnings yet'
                  : 'No payments yet'}
              </h2>
              <p>
                {activeTab === 'earnings'
                  ? 'Your earnings will appear here once you start receiving orders'
                  : 'Your payments will appear here once Artiza disburses funds to you'}
              </p>
            </div>
          ) : (
            <>
              <div className="earnings-table-wrapper">
                <table className="earnings-table">
                  <thead>
                    <tr>
                      {activeTab === 'earnings' ? (
                        <>
                          <th>Earning ID</th>
                          <th>Order</th>
                          <th>Products</th>
                          <th>Colors</th>
                          <th>Gross</th>
                          <th>Commission</th>
                          <th>Net</th>
                          <th>Paid</th>
                          <th>Remaining</th>
                          <th>Status</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </>
                      ) : (
                        <>
                          <th>Payment ID</th>
                          <th>Products</th>
                          <th>Amount</th>
                          <th>Method</th>
                          <th>Reference</th>
                          <th>Date</th>
                          <th>Actions</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((item) => {
                      if (activeTab === 'earnings') {
                        const earning = item;
                        const statusConfig = getStatusConfig(earning.status);
                        const StatusIcon = statusConfig.icon;
                        const products = earning.products || [];
                        const isExpanded = expandedEarning === earning.id;

                        return (
                          <React.Fragment key={earning.id}>
                            <tr className={earning.status}>
                              <td>
                                <div className="earning-id">
                                  #{earning.id}
                                </div>
                              </td>
                              <td>
                                <div className="order-info">
                                  <div className="order-id">
                                    #{earning.customer_order_id}
                                  </div>
                                  <div className="order-artisan">
                                    {earning.artisan_name}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="product-info-cell">
                                  {products.length > 0 &&
                                    products[0].product_image && (
                                      <img
                                        src={products[0].product_image}
                                        alt={products[0].product_name}
                                        className="product-thumb-small"
                                      />
                                    )}
                                  <div className="product-names">
                                    <span className="product-name-main">
                                      {getProductSummary(products)}
                                    </span>
                                    {products.length > 1 && (
                                      <button
                                        className="expand-btn"
                                        onClick={() =>
                                          toggleExpandEarning(earning.id)
                                        }
                                      >
                                        {isExpanded ? 'Hide' : 'Show all'} (
                                        {products.length})
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="color-info-cell">
                                  {products
                                    .slice(0, 3)
                                    .map(
                                      (product, idx) =>
                                        product.color_name && (
                                          <span
                                            key={idx}
                                            className="color-item"
                                          >
                                            <span
                                              className="color-dot-small"
                                              style={{
                                                backgroundColor:
                                                  product.color_code ||
                                                  '#ccc',
                                              }}
                                            />
                                            <span className="color-name-small">
                                              {product.color_name}
                                            </span>
                                          </span>
                                        ),
                                    )}
                                  {products.length > 3 && (
                                    <span className="more-colors">
                                      +{products.length - 3}
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="amount">
                                {formatCurrency(earning.gross_amount)}
                              </td>
                              <td className="commission">
                                <div className="commission-details">
                                  <span className="commission-rate">
                                    {earning.commission_rate}%
                                  </span>
                                  <span className="commission-amount">
                                    -{formatCurrency(earning.commission_amount)}
                                  </span>
                                </div>
                              </td>
                              <td className="net-amount">
                                <strong>
                                  {formatCurrency(earning.net_amount)}
                                </strong>
                              </td>
                              <td className="amount">
                                {earning.amount_disbursed > 0
                                  ? formatCurrency(earning.amount_disbursed)
                                  : '—'}
                              </td>
                              <td className="amount">
                                {earning.amount_remaining > 0
                                  ? formatCurrency(earning.amount_remaining)
                                  : '—'}
                              </td>
                              <td>
                                <span
                                  className="status-badge"
                                  style={{
                                    background: statusConfig.bg,
                                    color: statusConfig.color,
                                  }}
                                >
                                  <StatusIcon />
                                  {statusConfig.label}
                                </span>
                              </td>
                              <td>
                                <div className="earning-date">
                                  {formatDate(earning.created_at)}
                                </div>
                              </td>
                              <td>
                                <div className="action-buttons">
                                  <button
                                    className="view-btn"
                                    onClick={() => handleViewEarning(earning)}
                                    title="View details"
                                  >
                                    <FaEye />
                                  </button>
                                </div>
                              </td>
                            </tr>
                            {isExpanded && products.length > 1 && (
                              <tr className="expanded-products-row">
                                <td colSpan="12">
                                  <div className="expanded-products">
                                    <div className="expanded-products-header">
                                      <FaBox /> Products in this order
                                    </div>
                                    <div className="expanded-products-list">
                                      {products.map((product, idx) => (
                                        <div
                                          key={idx}
                                          className="expanded-product-item"
                                        >
                                          <div className="expanded-product-image">
                                            {product.product_image ? (
                                              <img
                                                src={product.product_image}
                                                alt={product.product_name}
                                              />
                                            ) : (
                                              <div className="no-image">
                                                <FaBox />
                                              </div>
                                            )}
                                          </div>
                                          <div className="expanded-product-details">
                                            <div className="expanded-product-name">
                                              {product.product_name}
                                            </div>
                                            <div className="expanded-product-meta">
                                              {product.color_name && (
                                                <span className="expanded-product-color">
                                                  <span
                                                    className="color-dot"
                                                    style={{
                                                      backgroundColor:
                                                        product.color_code ||
                                                        '#ccc',
                                                    }}
                                                  />
                                                  {product.color_name}
                                                </span>
                                              )}
                                              <span className="expanded-product-qty">
                                                Qty: {product.quantity}
                                              </span>
                                              <span className="expanded-product-price">
                                                {formatCurrency(
                                                  product.unit_price,
                                                )}{' '}
                                                each
                                              </span>
                                            </div>
                                          </div>
                                          <div className="expanded-product-total">
                                            {formatCurrency(
                                              product.total_price,
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      } else {
                        const disbursement = item;
                        const products = disbursement.products || [];
                        const isExpanded =
                          expandedDisbursement === disbursement.id;

                        return (
                          <React.Fragment key={disbursement.id}>
                            <tr>
                              <td>
                                <div className="disbursement-id">
                                  #{disbursement.id}
                                </div>
                              </td>
                              <td>
                                <div className="product-info-cell">
                                  {products.length > 0 &&
                                    products[0].product_image && (
                                      <img
                                        src={products[0].product_image}
                                        alt={products[0].product_name}
                                        className="product-thumb-small"
                                      />
                                    )}
                                  <div className="product-names">
                                    <span className="product-name-main">
                                      {getDisbursementProductSummary(
                                        disbursement,
                                      )}
                                    </span>
                                    {products.length > 1 && (
                                      <button
                                        className="expand-btn"
                                        onClick={() =>
                                          toggleExpandDisbursement(
                                            disbursement.id,
                                          )
                                        }
                                      >
                                        {isExpanded ? 'Hide' : 'Show all'} (
                                        {products.length})
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td className="amount">
                                <strong>
                                  {formatCurrency(disbursement.amount)}
                                </strong>
                              </td>
                              <td>
                                <span
                                  className={`payment-method-badge ${disbursement.payment_method}`}
                                >
                                  {disbursement.payment_method === 'mpesa'
                                    ? '📱 M-Pesa'
                                    : '🏦 Bank'}
                                </span>
                              </td>
                              <td>
                                <span className="reference-text">
                                  {disbursement.transaction_reference || 'N/A'}
                                </span>
                              </td>
                              <td>
                                <div className="disbursement-date">
                                  {formatDate(
                                    disbursement.disbursed_at ||
                                      disbursement.created_at,
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className="action-buttons">
                                  <button
                                    className="view-btn"
                                    onClick={() =>
                                      handleViewDisbursement(disbursement)
                                    }
                                    title="View details"
                                  >
                                    <FaEye />
                                  </button>
                                </div>
                              </td>
                            </tr>
                            {isExpanded && products.length > 1 && (
                              <tr className="expanded-products-row">
                                <td colSpan="7">
                                  <div className="expanded-products">
                                    <div className="expanded-products-header">
                                      <FaBox /> Products in this payment
                                    </div>
                                    <div className="expanded-products-list">
                                      {products.map((product, idx) => (
                                        <div
                                          key={idx}
                                          className="expanded-product-item"
                                        >
                                          <div className="expanded-product-image">
                                            {product.product_image ? (
                                              <img
                                                src={product.product_image}
                                                alt={product.product_name}
                                              />
                                            ) : (
                                              <div className="no-image">
                                                <FaBox />
                                              </div>
                                            )}
                                          </div>
                                          <div className="expanded-product-details">
                                            <div className="expanded-product-name">
                                              {product.product_name}
                                            </div>
                                            <div className="expanded-product-meta">
                                              {product.color_name && (
                                                <span className="expanded-product-color">
                                                  <span
                                                    className="color-dot"
                                                    style={{
                                                      backgroundColor:
                                                        product.color_code ||
                                                        '#ccc',
                                                    }}
                                                  />
                                                  {product.color_name}
                                                </span>
                                              )}
                                              <span className="expanded-product-qty">
                                                Qty: {product.quantity}
                                              </span>
                                              <span className="expanded-product-price">
                                                {formatCurrency(
                                                  product.unit_price,
                                                )}{' '}
                                                each
                                              </span>
                                            </div>
                                          </div>
                                          <div className="expanded-product-total">
                                            {formatCurrency(
                                              product.total_price,
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      }
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="pagination">
                  <button
                    className="pagination-btn"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <FaChevronLeft />
                  </button>
                  <span className="page-info">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    className="pagination-btn"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <FaChevronRight />
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        {/* ============================================= */}
        {/* EARNING DETAIL MODAL */}
        {/* ============================================= */}
        <Modal
          show={showEarningModal}
          onHide={() => setShowEarningModal(false)}
          size="xl"
          centered
          className="earning-detail-modal"
        >
          {selectedEarning && (
            <>
              <Modal.Header closeButton>
                <h2>Earning Details</h2>
              </Modal.Header>
              <Modal.Body>
                <div className="earning-detail-content">
                  <div className="earning-summary-header">
                    <div className="earning-main-info">
                      <div className="earning-id-badge">
                        Earning #{selectedEarning.id}
                      </div>
                      <div className="earning-amount-large">
                        {formatCurrency(selectedEarning.net_amount)}
                      </div>
                      <div className="earning-status">
                        {(() => {
                          const config = getStatusConfig(
                            selectedEarning.status,
                          );
                          const Icon = config.icon;
                          return (
                            <span
                              className="status-badge-large"
                              style={{
                                background: config.bg,
                                color: config.color,
                              }}
                            >
                              <Icon />
                              {config.label}
                            </span>
                          );
                        })()}
                      </div>
                    </div>
                  </div>

                  {selectedEarning.products &&
                    selectedEarning.products.length > 0 && (
                      <div className="products-section">
                        <h4>
                          <FaBox /> Products
                        </h4>
                        <div className="products-list">
                          {selectedEarning.products.map((product, idx) => (
                            <div key={idx} className="product-item">
                              <div className="product-image">
                                {product.product_image ? (
                                  <img
                                    src={product.product_image}
                                    alt={product.product_name}
                                  />
                                ) : (
                                  <div className="no-image">
                                    <FaBox />
                                  </div>
                                )}
                              </div>
                              <div className="product-details">
                                <div className="product-name">
                                  {product.product_name}
                                </div>
                                <div className="product-meta">
                                  {product.color_name && (
                                    <span className="product-color">
                                      <span
                                        className="color-dot"
                                        style={{
                                          backgroundColor:
                                            product.color_code || '#ccc',
                                        }}
                                      />
                                      {product.color_name}
                                    </span>
                                  )}
                                  <span className="product-qty">
                                    Qty: {product.quantity}
                                  </span>
                                  <span className="product-price">
                                    {formatCurrency(product.unit_price)} each
                                  </span>
                                </div>
                              </div>
                              <div className="product-total">
                                {formatCurrency(product.total_price)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                  <div className="financial-breakdown">
                    <h4>Financial Breakdown</h4>
                    <div className="breakdown-grid">
                      <div className="breakdown-item">
                        <span className="breakdown-label">Gross Amount</span>
                        <span className="breakdown-value">
                          {formatCurrency(selectedEarning.gross_amount)}
                        </span>
                      </div>
                      <div className="breakdown-item">
                        <span className="breakdown-label">
                          Commission ({selectedEarning.commission_rate}%)
                        </span>
                        <span className="breakdown-value negative">
                          -
                          {formatCurrency(selectedEarning.commission_amount)}
                        </span>
                      </div>
                      <div className="breakdown-item total">
                        <span className="breakdown-label">Net Amount</span>
                        <span className="breakdown-value total">
                          {formatCurrency(selectedEarning.net_amount)}
                        </span>
                      </div>
                      <div className="breakdown-item">
                        <span className="breakdown-label">Amount Paid</span>
                        <span className="breakdown-value">
                          {formatCurrency(selectedEarning.amount_disbursed || 0)}
                        </span>
                      </div>
                      <div className="breakdown-item">
                        <span className="breakdown-label">Remaining</span>
                        <span className="breakdown-value">
                          {formatCurrency(selectedEarning.amount_remaining || 0)}
                        </span>
                      </div>
                      {selectedEarning.paid_at && (
                        <div className="breakdown-item">
                          <span className="breakdown-label">Paid At</span>
                          <span className="breakdown-value">
                            {formatDate(selectedEarning.paid_at)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="order-information">
                    <h4>Order Information</h4>
                    <div className="info-grid">
                      <div className="info-item">
                        <span className="info-label">Order ID</span>
                        <span className="info-value">
                          #{selectedEarning.customer_order_id}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Artisan</span>
                        <span className="info-value">
                          {selectedEarning.artisan_name}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Email</span>
                        <span className="info-value">
                          {selectedEarning.artisan_email}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="info-label">Created</span>
                        <span className="info-value">
                          {formatDate(selectedEarning.created_at)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowEarningModal(false)}
                >
                  Close
                </button>
              </Modal.Footer>
            </>
          )}
        </Modal>

        {/* ============================================= */}
        {/* DISBURSEMENT DETAIL MODAL */}
        {/* ============================================= */}
        <Modal
          show={showDisbursementModal}
          onHide={() => setShowDisbursementModal(false)}
          size="lg"
          centered
          className="disbursement-detail-modal"
        >
          {selectedDisbursement && (
            <>
              <Modal.Header closeButton>
                <h2>Payment Details</h2>
              </Modal.Header>
              <Modal.Body>
                <div className="disbursement-detail-content">
                  <div className="disbursement-summary-header">
                    <div className="disbursement-main-info">
                      <div className="disbursement-id-badge">
                        Payment #{selectedDisbursement.id}
                      </div>
                      <div className="disbursement-amount-large">
                        {formatCurrency(selectedDisbursement.amount)}
                      </div>
                      <div className="disbursement-method">
                        <span
                          className={`method-badge ${selectedDisbursement.payment_method}`}
                        >
                          {selectedDisbursement.payment_method === 'mpesa'
                            ? '📱 M-Pesa'
                            : '🏦 Bank Transfer'}
                        </span>
                      </div>
                    </div>
                  </div>

                  {selectedDisbursement.products &&
                    selectedDisbursement.products.length > 0 && (
                      <div className="products-section">
                        <h4>
                          <FaBox /> Products in this payment
                        </h4>
                        <div className="products-list">
                          {selectedDisbursement.products.map(
                            (product, idx) => (
                              <div key={idx} className="product-item">
                                <div className="product-image">
                                  {product.product_image ? (
                                    <img
                                      src={product.product_image}
                                      alt={product.product_name}
                                    />
                                  ) : (
                                    <div className="no-image">
                                      <FaBox />
                                    </div>
                                  )}
                                </div>
                                <div className="product-details">
                                  <div className="product-name">
                                    {product.product_name}
                                  </div>
                                  <div className="product-meta">
                                    {product.color_name && (
                                      <span className="product-color">
                                        <span
                                          className="color-dot"
                                          style={{
                                            backgroundColor:
                                              product.color_code || '#ccc',
                                          }}
                                        />
                                        {product.color_name}
                                      </span>
                                    )}
                                    <span className="product-qty">
                                      Qty: {product.quantity}
                                    </span>
                                    <span className="product-price">
                                      {formatCurrency(product.unit_price)} each
                                    </span>
                                  </div>
                                </div>
                                <div className="product-total">
                                  {formatCurrency(product.total_price)}
                                </div>
                              </div>
                            ),
                          )}
                        </div>
                      </div>
                    )}

                  <div className="disbursement-details-grid">
                    <div className="detail-item">
                      <span className="label">Earning ID</span>
                      <span className="value">
                        #{selectedDisbursement.earning_id || 'N/A'}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="label">Order ID</span>
                      <span className="value">
                        #{selectedDisbursement.customer_order_id || 'N/A'}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="label">Transaction Reference</span>
                      <span className="value">
                        {selectedDisbursement.transaction_reference || 'N/A'}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="label">Payment Date</span>
                      <span className="value">
                        {formatDate(
                          selectedDisbursement.disbursed_at ||
                            selectedDisbursement.created_at,
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowDisbursementModal(false)}
                >
                  Close
                </button>
              </Modal.Footer>
            </>
          )}
        </Modal>
      </div>
    </>
  );
};

export default withAuth(ArtisanEarnings, 'artisan');